import apiClient from '@/config/api';
import type { StatisticsOverview } from '@/types/statistics';

export const statisticsApi = {
  getOverview: async (days: 7 | 30 | 90): Promise<StatisticsOverview> => {
    const response = await apiClient.get('/admin/statistics/overview', {
      params: { days: String(days) },
    });
    return response.data.data;
  },
};
